import { css } from '@emotion/react';
import { applyFont, tokens } from '@domain-group/fe-brary';
import { media } from '../../../../styles/breakpoints-2026';

const { borderRadius, colors, spacing, typography } = tokens;

const agentAvatarSize = 96;
const agentAvatarSizeTablet = 88;
const agentAvatarSizeMobile = 80;

export const agentAvatar = css`
  overflow: hidden;
  border-radius: ${borderRadius.inner};
  width: ${agentAvatarSize}px;
  height: ${agentAvatarSize}px;

  ${media('>=tablet', '<desktop')} {
    width: ${agentAvatarSizeTablet}px;
    height: ${agentAvatarSizeTablet}px;
  }

  ${media('<tablet')} {
    width: ${agentAvatarSizeMobile}px;
    height: ${agentAvatarSizeMobile}px;
  }
`;

export const agentAvatarPlaceholder = css`
  ${agentAvatar}
  display: flex;
  align-items: flex-end;
  justify-content: center;
  background-color: ${colors.neutral.subdued.default};
`;

export const agentAvatarPlaceholderIcon = css`
  height: 77px;
  width: auto;
  color: ${colors.secondary.trim.hover};
`;

export const stat = css`
  display: flex;
  flex-direction: column;
  gap: ${spacing.xxs};
`;

export const statValue = css`
  ${applyFont(typography.body)}
  color: ${colors.neutral.heavy.default};
`;

export const statLabel = css`
  ${applyFont(typography.mini)}
  color: ${colors.neutral.medium.default};
`;
